import React from 'react';
import './SkeletonLoader.css';

interface SkeletonLoaderProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  className?: string;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  width = '100%',
  height = '1rem',
  borderRadius = '0.25rem',
  className = ''
}) => (
    <div
      className={`skeleton-loader ${className}`}
      style={{
        width,
        height,
        borderRadius
      }}
    />
  );

export default SkeletonLoader;